import React, { useState, useEffect, useMemo, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  getScheduleData,
  saveTemplateSlot,
  addDayOff,
  addBlockerSlot,
  deleteScheduleEntry,
} from "../../actions/scheduleActions";
import MessageModal from "../Pages/MessageModel";

// --- Helper Functions (No changes needed) ---
// const getDayInfo = (date) => {
//   const days = [
//     "Sunday",
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//     "Saturday",
//   ];
//   return {
//     name: days[date.getDay()],
//     dateStr: date.toISOString().split("T")[0],
//   };
// };
const getDayInfo = (date) => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  
  // Local date nikalne ka sahi tarika (YYYY-MM-DD)
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const dateStr = `${year}-${month}-${day}`;

  return {
    name: days[date.getDay()],
    dateStr: dateStr,
  };
};
// const getWeekDays = (weekOffset = 0) => {
//   const today = new Date();
//   const monday = new Date(today);
//   const currentDay = monday.getDay();
//   const diff = (currentDay === 0 ? -6 : 1) - currentDay;
//   monday.setDate(today.getDate() + diff + weekOffset * 7);

//   return Array.from({ length: 7 }, (_, i) => {
//     const date = new Date(monday);
//     date.setDate(monday.getDate() + i);
//     const { name, dateStr } = getDayInfo(date);
//     return {
//       name,
//       key: `${name.toLowerCase()}_${dateStr}`,
//       date: dateStr,
//       isToday: date.toDateString() === new Date().toDateString(),
//     };
//   });
// };
const getWeekDays = (weekOffset = 0) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Time zero karein taaki calculation hamesha current date se ho
  
  const monday = new Date(today);
  const currentDay = today.getDay();
  
  // Monday calculation logic
  const diff = (currentDay === 0 ? -6 : 1) - currentDay;
  monday.setDate(today.getDate() + diff + weekOffset * 7);

  return Array.from({ length: 7 }, (_, i) => {
    const date = new Date(monday);
    date.setDate(monday.getDate() + i);
    const { name, dateStr } = getDayInfo(date);
    return {
      name,
      key: `${name.toLowerCase()}_${dateStr}`,
      date: dateStr,
      isToday: date.toDateString() === new Date().toDateString(),
    };
  });
};
const convertToMinutesFromParts = (hour, minute, period) => {
  let h = parseInt(hour, 10);
  const m = parseInt(minute, 10);
  if (period === "PM" && h !== 12) h += 12;
  if (period === "AM" && h === 12) h = 0;
  return h * 60 + m;
};

const convertToMinutes = (timeStr12h) => {
  if (!timeStr12h) return null;
  const parts = timeStr12h.match(/(\d+):(\d+)\s(AM|PM)/);
  if (!parts) return null;
  let [, hour, minute, period] = parts;
  return convertToMinutesFromParts(hour, minute, period);
};

const formatMinutesTo12h = (totalMinutes) => {
  if (totalMinutes === null || isNaN(totalMinutes) || totalMinutes < 0)
    return "";
  const hours24 = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const period = hours24 >= 12 ? "PM" : "AM";
  let hours12 = hours24 % 12;
  if (hours12 === 0) hours12 = 12;
  return `${hours12.toString()}:${minutes.toString().padStart(2, "0")} ${period}`;
};

const isTimeOverlapping = (slotA, slotB) => {
  return slotA.start < slotB.end && slotA.end > slotB.start;
};

const HOUR_OPTIONS = Array.from({ length: 12 }, (_, i) => (i + 1).toString());
const MINUTE_OPTIONS = ["00", "15", "30", "45", "60"];
const PERIOD_OPTIONS = ["AM", "PM"];
const APPOINTMENT_TYPES = ["Online", "Offline"];
// --- Main Component ---
const ScheduleTime = ({
  templateSlots,
  daysOff,
  blockers,
  isLoading,
  getScheduleData,
  saveTemplateSlot,
  addDayOff,
  addBlockerSlot,
  deleteScheduleEntry,
}) => {
  const styles = {
    cardHeader: {
      padding: "1rem",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#f8f9fa",
      borderBottom: "1px solid #dee2e6",
    },
    cardBody: { padding: "1.5rem" },
    loadingOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.85)",
      backdropFilter: "blur(2px)",
      zIndex: 1050,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "0.375rem",
      color: "#333",
    },
    tabContainer: {
      display: "flex",
      justifyContent: "space-around",
      borderBottom: "1px solid #dee2e6",
    },
    tabLink: {
      flex: 1,
      padding: "10px 5px",
      textAlign: "center",
      cursor: "pointer",
      borderBottom: "3px solid transparent",
      transition: "all 0.2s ease-in-out",
      color: "#6c757d",
      position: "relative",
    },
    tabLinkActive: {
      borderBottomColor: "#0d6efd",
      color: "#0d6efd",
      fontWeight: "600",
    },
    slotItem: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "1rem",
      border: "1px solid #eee",
      borderRadius: "0.25rem",
      marginBottom: "0.5rem",
      backgroundColor: "#fff",
    },
    deleteButton: {
      background: "none",
      border: "none",
      color: "#dc3545",
      cursor: "pointer",
      padding: "0 5px",
      fontSize: "1.2rem",
      opacity: 0,
      transition: "opacity 0.2s ease-in-out",
    },
    modalBackdrop: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 1040,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    modalContent: {
      backgroundColor: "#fff",
      borderRadius: "0.3rem",
      width: "500px",
      maxWidth: "90%",
      boxShadow: "0 0.5rem 1rem rgba(0,0,0,0.15)",
    },
    modalHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "1rem",
      borderBottom: "1px solid #dee2e6",
      backgroundColor: "#0084d9",
      color: "#fff",
    },
    
    modalBody: { padding: "1rem" },
    modalFooter: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "0.5rem",
      padding: "1rem",
      borderTop: "1px solid #dee2e6",
    },
    blockerItem: { backgroundColor: "#ffebe6", borderColor: "#f5c6cb" },
  };

  const hospitalID = parseInt(localStorage.getItem("hospitalCode"), 10);
  const [offset, setOffset] = useState(0);
  const [weekDays, setWeekDays] = useState(getWeekDays(0));
  const [selectedDayKey, setSelectedDayKey] = useState(
    () => getWeekDays(0).find((d) => d.isToday)?.key || getWeekDays(0)[0].key,
  );
  // Component ke andar sabse upar ye line likhein
  const [typeFilter, setTypeFilter] = useState("All");
  const [messageModal, setMessageModal] = useState({
    show: false,
    title: "",
    message: "",
    variant: "info",
  });
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isBlockerModalOpen, setIsBlockerModalOpen] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState({
    show: false,
    entryId: null,
  });
  const [newSlots, setNewSlots] = useState([]);
 
  const [newBlocker, setNewBlocker] = useState({});
  const [modalError, setModalError] = useState("");

  const [isSavingSlots, setIsSavingSlots] = useState(false);
  const [isSavingBlocker, setIsSavingBlocker] = useState(false);
  const [isTogglingDayOff, setIsTogglingDayOff] = useState(false);

  useEffect(() => {
    if (hospitalID) {
      getScheduleData({ hospitalID });
    }
  }, [hospitalID, getScheduleData]);

  useEffect(() => {
    setWeekDays(getWeekDays(offset));
  }, [offset]);

  useEffect(() => {
  if (isAddModalOpen) {
    setModalError("");
    setNewSlots([
      {
        start: { hour: "", minute: "", period: "" },
        end: { hour: "", minute: "", period: "" },
        type: "Offline", // Default type har slot ke liye alag
      },
    ]);
  }
}, [isAddModalOpen]);

  useEffect(() => {
    if (isBlockerModalOpen) {
      setModalError("");
      setNewBlocker({
        start: { hour: "", minute: "", period: "" },
        end: { hour: "", minute: "", period: "" },
      });
    }
  }, [isBlockerModalOpen]);

  const handleSaveSlots = async () => {
    setModalError("");
    setIsSavingSlots(true);

    for (const slot of newSlots) {
      if (
        !slot.start.hour ||
        !slot.start.minute ||
        !slot.start.period ||
        !slot.end.hour ||
        !slot.end.minute ||
        !slot.end.period
      ) {
        setModalError("Please fill in all time fields for all slots.");
        setIsSavingSlots(false);
        return;
      }
    }
    const newSlotsInMinutes = newSlots.map((slot) => ({
      start: convertToMinutesFromParts(
        slot.start.hour,
        slot.start.minute,
        slot.start.period,
      ),
      end: convertToMinutesFromParts(
        slot.end.hour,
        slot.end.minute,
        slot.end.period,
      ),
    }));
    for (const slot of newSlotsInMinutes) {
      if (slot.start >= slot.end) {
        setModalError("End time must be after the start time for all slots.");
        setIsSavingSlots(false);
        return;
      }
    }

    const selectedDay = weekDays.find((d) => d.key === selectedDayKey);
    const dayTemplateSlots = (templateSlots || []).filter(
      (s) => s?.day === selectedDay.name && !s.date,
    );
    const dayBlockers = (blockers || []).filter(
      (b) => b?.date === selectedDay.date,
    );

    const existingScheduleRanges = [
      ...dayTemplateSlots.map((s) => ({
        start: convertToMinutes(s.slot.split(" - ")[0]),
        end: convertToMinutes(s.slot.split(" - ")[1]),
      })),
      ...dayBlockers.map((b) => ({
        start: convertToMinutes(b.slot.split(" - ")[0]),
        end: convertToMinutes(b.slot.split(" - ")[1]),
      })),
    ].filter((r) => r.start !== null);

    const newSlotStrings = newSlotsInMinutes.map(
      (slot) =>
        `${formatMinutesTo12h(slot.start)} - ${formatMinutesTo12h(slot.end)}`,
    );
    if (new Set(newSlotStrings).size !== newSlotStrings.length) {
      setModalError("You have entered duplicate time slots in the form.");
      setIsSavingSlots(false);
      return;
    }

    for (let i = 0; i < newSlotsInMinutes.length; i++) {
      const newSlot = newSlotsInMinutes[i];

      if (dayTemplateSlots.some((ts) => ts.slot === newSlotStrings[i])) {
        setModalError(
          `The slot ${newSlotStrings[i]} already exists in the template.`,
        );
        setIsSavingSlots(false);
        return;
      }

      for (let j = i + 1; j < newSlotsInMinutes.length; j++) {
        if (isTimeOverlapping(newSlot, newSlotsInMinutes[j])) {
          setModalError(
            `The new slots ${newSlotStrings[i]} and ${newSlotStrings[j]} are overlapping.`,
          );
          setIsSavingSlots(false);
          return;
        }
      }

      for (const existingRange of existingScheduleRanges) {
        if (isTimeOverlapping(newSlot, existingRange)) {
          setModalError(
            `The slot ${newSlotStrings[i]} overlaps with an existing schedule entry.`,
          );
          setIsSavingSlots(false);
          return;
        }
      }
    }

    const slotsToCreate = newSlotsInMinutes.map((slot, index) => ({
  hospitalID,
  day: selectedDay.name,
  slot: `${formatMinutesTo12h(slot.start)} - ${formatMinutesTo12h(slot.end)}`,
  date: "",
  AppoinmentFor: newSlots[index].type, // Yahan se individual type milega
}));

    try {
      await Promise.all(slotsToCreate.map((slot) => saveTemplateSlot(slot)));
      getScheduleData({ hospitalID });
      setMessageModal({
        show: true,
        title: "Success",
        message: "Template slots have been saved successfully!",
        variant: "success",
      });
      setIsAddModalOpen(false);
    } catch (error) {
      setMessageModal({
        show: true,
        title: "Error",
        message: "Could not save the new slots. Please try again.",
        variant: "danger",
      });
    } finally {
      setIsSavingSlots(false);
    }
  };

  const handleAddBlocker = async () => {
    setModalError("");
    setIsSavingBlocker(true);

    if (
      !newBlocker.start.hour ||
      !newBlocker.start.minute ||
      !newBlocker.start.period ||
      !newBlocker.end.hour ||
      !newBlocker.end.minute ||
      !newBlocker.end.period
    ) {
      setModalError("Please fill in all time fields.");
      setIsSavingBlocker(false);
      return;
    }

    const startMinutes = convertToMinutesFromParts(
      newBlocker.start.hour,
      newBlocker.start.minute,
      newBlocker.start.period,
    );
    const endMinutes = convertToMinutesFromParts(
      newBlocker.end.hour,
      newBlocker.end.minute,
      newBlocker.end.period,
    );

    if (startMinutes >= endMinutes) {
      setModalError("End time must be after start time.");
      setIsSavingBlocker(false);
      return;
    }

    const newBlockerRange = { start: startMinutes, end: endMinutes };
    const selectedDay = weekDays.find((d) => d.key === selectedDayKey);

    // *** LOGIC FIX: Only validate against other blockers on the same day ***
    const dayBlockers = (blockers || []).filter(
      (b) => b?.date === selectedDay.date,
    );
    const existingBlockerRanges = dayBlockers
      .map((b) => ({
        start: convertToMinutes(b.slot.split(" - ")[0]),
        end: convertToMinutes(b.slot.split(" - ")[1]),
      }))
      .filter((r) => r.start !== null);

    for (const existingRange of existingBlockerRanges) {
      if (isTimeOverlapping(newBlockerRange, existingRange)) {
        setModalError(
          "This period overlaps with an existing unavailability entry for this date.",
        );
        setIsSavingBlocker(false);
        return;
      }
    }

    const payload = {
      hospitalID,
      day: selectedDay.name,
      date: selectedDay.date,
      slot: `${formatMinutesTo12h(startMinutes)} - ${formatMinutesTo12h(endMinutes)}`,
      AppoinmentFor: " ",
    };

    try {
      await addBlockerSlot(payload);
      getScheduleData({ hospitalID });
      setMessageModal({
        show: true,
        title: "Success",
        message: "Unavailability period has been added.",
        variant: "success",
      });
      setIsBlockerModalOpen(false);
    } catch (error) {
      setMessageModal({
        show: true,
        title: "Error",
        message: "Could not add blocker.",
        variant: "danger",
      });
    } finally {
      setIsSavingBlocker(false);
    }
  };
//   const handleToggleType = async (item) => {
//   const newType = item.AppoinmentFor === "Online" ? "Offline" : "Online";
//   try {
//     // Assuming you have an update action. If not, we delete and re-add:
//     await deleteScheduleEntry({ id: item.id, hospitalID });
//     await saveTemplateSlot({
//       ...item,
//       AppoinmentFor: newType,
//       hospitalID
//     });
//     getScheduleData({ hospitalID });
//   } catch (error) {
//     console.error("Failed to toggle type", error);
//   }
// };

// Function to toggle Availability (Available <-> Unavailable)
// const handleToggleAvailability = async (item) => {
//   try {
//     if (item.type === "template") {
//       // Switch to Unavailable: Create a blocker and delete the template slot
//       await addBlockerSlot({
//         hospitalID,
//         day: selectedDay.name,
//         date: selectedDay.date,
//         slot: item.slot,
//         AppoinmentFor: " "
//       });
//       // Optional: If you want to keep the template but just block it for today, 
//       // don't delete the template entry.
//     } else {
//       // Switch to Available: Delete the blocker
//       await handleDelete(item.id);
//     }
//     getScheduleData({ hospitalID });
//   } catch (error) {
//     console.error("Failed to toggle availability", error);
//   }
// };
const handleToggleType = async (item) => {
    const newType = item.AppoinmentFor === "Online" ? "Offline" : "Online";
    try {
        // Purane slot ko delete karke naye type ke saath save karein
        await deleteScheduleEntry({ id: item.id, hospitalID });
        await saveTemplateSlot({
            hospitalID,
            day: item.day,
            slot: item.slot,
            date: "",
            AppoinmentFor: newType
        });
        getScheduleData({ hospitalID });
    } catch (error) {
        console.error("Error toggling type", error);
    }
};
const handleToggleAvailability = async (item) => {
  try {
    if (!item.isBlocked) {
      // Agar available hai toh isko "Block" (Unavailable) karo
      const payload = {
        hospitalID,
        day: selectedDay.name,
        date: selectedDay.date,
        slot: item.slot,
        AppoinmentFor: " ", 
      };
      await addBlockerSlot(payload);
    } else {
      // Agar pehle se blocked hai toh blocker delete karke "Available" karo
      await deleteScheduleEntry({ id: item.blockerId, hospitalID });
    }
    getScheduleData({ hospitalID });
  } catch (error) {
    console.error("Error toggling availability", error);
  }
};
  const handleDelete = (entryId) => {
    deleteScheduleEntry({ id: entryId, hospitalID });
    getScheduleData({ hospitalID });
    setMessageModal({
      show: true,
      title: "Success",
      message: "Schedule entry deleted.",
      variant: "success",
    });
  };

  const handleToggleDayOff = async (day) => {
    setIsTogglingDayOff(true);
    const dayOffMarker = daysOff.find((d) => d.date === day.date);
    try {
      if (dayOffMarker) {
        await deleteScheduleEntry({ id: dayOffMarker.id, hospitalID });
      } else {
        await addDayOff({
          hospitalID,
          date: day.date,
          day: day.name,
          slot: "DAY_OFF",
          AppoinmentFor: " ",
        });
      }
      getScheduleData({ hospitalID });
    } catch (error) {
      setMessageModal({
        show: true,
        title: "Error",
        message: "Could not update day status.",
        variant: "danger",
      });
    } finally {
      setIsTogglingDayOff(false);
    }
  };
const handleTemplateSlotFieldChange = (index, slotType, field, value) => {
  setNewSlots((currentSlots) =>
    currentSlots.map((item, i) => {
      if (i === index) {
        // Agar hum 'type' change kar rahe hain (Online/Offline)
        if (slotType === "type") {
          return { ...item, type: value };
        }
        // Baaki time fields ke liye purana logic
        return { ...item, [slotType]: { ...item[slotType], [field]: value } };
      }
      return item;
    })
  );
};

  const handleBlockerFieldChange = (slotType, field, value) => {
    setNewBlocker((currentBlocker) => ({
      ...currentBlocker,
      [slotType]: { ...currentBlocker[slotType], [field]: value },
    }));
  };

  const selectedDay = weekDays.find((d) => d.key === selectedDayKey);
  // const isDayOff = selectedDay && Array.isArray(daysOff) && daysOff.some(d => d?.date === selectedDay.date);
  const isDayOff =
    selectedDay &&
    Array.isArray(daysOff) &&
    daysOff.some((d) => d?.date === selectedDay.date);
  // const unifiedScheduleForDay = useMemo(() => {
  //   if (!selectedDay) return [];
  //   if (isDayOff) return [{ id: "holiday", type: "holiday" }];

  //   const allEntries = [...(templateSlots || []), ...(blockers || [])].filter(
  //     Boolean,
  //   );
  //   const uniqueEntries = Array.from(
  //     new Map(allEntries.map((item) => [item.id, item])).values(),
  //   );

  //   const dayBlockers = uniqueEntries.filter(
  //     (b) => b?.date === selectedDay.date && b.type !== "DAY_OFF",
  //   );
  //   const dayTemplateSlots = uniqueEntries.filter(
  //     (s) => s?.day === selectedDay.name && (!s.date || s.date === ""),
  //   );

  //   const processedTemplateSlots = dayTemplateSlots.map((slot) => ({
  //     ...slot,
  //     type: "template",
  //   }));
  //   const processedBlockers = dayBlockers.map((blocker) => ({
  //     ...blocker,
  //     type: "blocker",
  //   }));
  //   const combined = [...processedTemplateSlots, ...processedBlockers];

  //   return combined.sort((a, b) => {
  //     const startTimeA = convertToMinutes(a.slot.split(" - ")[0]);
  //     const startTimeB = convertToMinutes(b.slot.split(" - ")[0]);
  //     return (startTimeA || 0) - (startTimeB || 0);
  //   });
  // }, [selectedDay, templateSlots, daysOff, blockers, isDayOff]);
  const unifiedScheduleForDay = useMemo(() => {
  if (!selectedDay) return [];
  if (isDayOff) return [{ id: "holiday", type: "holiday" }];

  // 1. Aaj ke din ke saare template slots lo
  const dayTemplateSlots = (templateSlots || []).filter(
    (s) => s?.day === selectedDay.name && (!s.date || s.date === "")
  );

  // 2. Aaj ke din ke saare blockers (unavailability) lo
  const dayBlockers = (blockers || []).filter(
    (b) => b?.date === selectedDay.date && b.type !== "DAY_OFF"
  );

  // 3. Template slots ko process karo aur check karo ki kya wo blocked hain
  const combined = dayTemplateSlots.map((slot) => {
    // Check karo agar is slot ka exact time koi blocker mein hai
    const blockerForThisSlot = dayBlockers.find(b => b.slot === slot.slot);
    
    return {
      ...slot,
      type: "template",
      isBlocked: !!blockerForThisSlot, // Agar blocker mila toh true
      blockerId: blockerForThisSlot ? blockerForThisSlot.id : null // Delete karne ke liye kaam aayega
    };
  });

  // 4. Sort by Time
  return combined.sort((a, b) => {
    const startTimeA = convertToMinutes(a.slot.split(" - ")[0]);
    const startTimeB = convertToMinutes(b.slot.split(" - ")[0]);
    return (startTimeA || 0) - (startTimeB || 0);
  });
}, [selectedDay, templateSlots, daysOff, blockers, isDayOff]);
  const filteredSchedule = useMemo(() => {
    if (typeFilter === "All") return unifiedScheduleForDay;

    return unifiedScheduleForDay.filter((item) => {
      // Holiday aur Blockers hamesha dikhao
      if (item.type === "holiday" || item.type === "blocker") return true;

      // Sirf wahi slots dikhao jo filter se match karein
      return item.AppoinmentFor === typeFilter;
    });
  }, [unifiedScheduleForDay, typeFilter]);
  return (
    <div>
      <div className="page-header filter-bar rounded mb-4">
        <div className="row align-items-center">
          <div className="col">
            <h4 className="page-title">Schedule-Timings</h4>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/doctor/dashboard">Doctor Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Schedule-Timings</li>
            </ul>
          </div>
        </div>
      </div>
      {/* --- Naya Filter & Buttons Card --- */}
      <div className="card shadow-sm mb-4">
        <div className="card-header bg-light border-bottom">
          <h4 className="card-title mb-0">Filter & Actions</h4>
        </div>
        <div className="card-body">
          <div className="row align-items-end">
            {/* Filter Dropdown */}
           <div className="col-md-4 form-group">
  <label className="fw-bold">Filter by Appointment Type</label>
  <select
    className="form-control"
    value={typeFilter}
    onChange={(e) => setTypeFilter(e.target.value)}
  >
     <option value="All">All Slots</option>
    <option value="Online">Online Slot</option>
    <option value="Offline">Offline Slot</option>
  </select>
</div>

           
            <div className="col-md-8 text-md-end mb-3">
              {!isDayOff && (
                <div className="d-flex flex-wrap gap-2 justify-content-md-end">
                  {/* <button
                    className="btn btn-danger rounded-pill"
                    onClick={() => setIsBlockerModalOpen(true)}
                  >
                    <i className="fa fa-clock me-1"></i> Add Unavailability
                  </button>
                  <button
                    className="btn btn-info rounded-pill"
                    onClick={() => setIsAddModalOpen(true)}
                  >
                    <i className="fa fa-plus me-1"></i> Add New Slots
                  </button> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="card position-relative">
        {isLoading && (
          <div style={styles.loadingOverlay}>
            <div className="spinner-border"></div>
            <p style={{ marginTop: "1rem", fontWeight: "bold" }}>Loading...</p>
          </div>
        )}

        <div style={styles.cardHeader}>
          <h3 style={{ margin: 0, fontSize: "1.25rem" }}>
            <i className="fa fa-calendar-alt me-2"></i>Schedule Management
          </h3>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            {/* <button className="btn btn-light border btn-sm" onClick={() => setOffset(0)} disabled={isLoading || offset === 0}>This Week</button> */}
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => setOffset(offset - 1)}
              disabled={isLoading}
            >
              ←
            </button>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => setOffset(offset + 1)}
              disabled={isLoading}
            >
              →
            </button>
          </div>
        </div>

        <div style={styles.cardBody}>
          {/* <div style={styles.tabContainer}>
                    {weekDays.map(day => ( <div key={day.key} style={{...styles.tabLink, ...(selectedDayKey === day.key && styles.tabLinkActive)}} onClick={() => !isLoading && setSelectedDayKey(day.key)}>
                        
                        <div style={{ fontWeight: 500 }}>{day.name}</div><small>{day.date.substring(5)}</small></div> ))}
                        
                </div> */}
          {/* <div style={styles.tabContainer}>
    {weekDays.map(day => {
        
const isThisDayOff = Array.isArray(daysOff) && daysOff.some(d => d?.date === day.date);
        return (
            <div 
                key={day.key} 
                style={{
                    ...styles.tabLink, 
                    ...(selectedDayKey === day.key && styles.tabLinkActive),
                    backgroundColor: isThisDayOff ? '#fff5f5' : 'transparent', 
                }} 
                onClick={() => !isLoading && setSelectedDayKey(day.key)}
            >
            
                <div style={{ fontWeight: 500 }}>{day.name}</div>
                <small className="text-muted">{day.date.substring(5)}</small>

               
                <div className="mt-2">
                    <span 
                        className={`badge rounded-pill px-2 py-1 ${isThisDayOff ? 'bg-danger' : 'bg-success'}`}
                        style={{ 
                            cursor: 'pointer', 
                            fontSize: '0.6rem',
                            display: 'inline-flex',
                            alignItems: 'center',
                            minWidth: '55px',
                            justifyContent: 'center'
                        }}
                        onClick={(e) => {
                            e.stopPropagation(); // Isse sirf holiday toggle hoga, tab switch nahi hoga
                            if (!isTogglingDayOff) handleToggleDayOff(day);
                        }}
                    >
                        {isTogglingDayOff && selectedDayKey === day.key ? (
                            <span className="spinner-border spinner-border-sm" style={{width: '10px', height: '10px'}}></span>
                        ) : (
                            <>
                                <i className={`fa ${isThisDayOff ? 'fa-times-circle' : 'fa-check-circle'} me-1`}></i>
                                {isThisDayOff ? 'Holiday' : 'Active'}
                            </>
                        )}
                    </span>
                    <span 
    className={`badge rounded-pill px-2 py-1 ${isThisDayOff ? 'bg-danger' : 'bg-success'}`}
    style={{ 
        cursor: 'pointer', 
        fontSize: '0.6rem',
        display: 'inline-flex',
        alignItems: 'center',
        minWidth: '55px',
        justifyContent: 'center'
    }}
    onClick={(e) => {
        e.preventDefault();
        e.stopPropagation(); 
    
        if (!isTogglingDayOff && day && day.date) {
            handleToggleDayOff(day);
        }
    }}
>
    {isTogglingDayOff && selectedDayKey === day.key ? (
        <span className="spinner-border spinner-border-sm" style={{width: '10px', height: '10px'}}></span>
    ) : (
        <>
            <i className={`fa ${isThisDayOff ? 'fa-times-circle' : 'fa-check-circle'} me-1`}></i>
            {isThisDayOff ? 'Holiday' : 'Active'}
        </>
    )}
</span>
                </div>
            </div>
        );
    })}
</div> */}
          <div style={styles.tabContainer}>
            {weekDays.map((day) => {
              // यह चेक करता है कि यह विशेष दिन Holiday है या नहीं
              const isThisDayOff =
                Array.isArray(daysOff) &&
                daysOff.some((d) => d?.date === day.date);

              return (
                <div
                  key={day.key}
                  style={{
                    ...styles.tabLink,
                    ...(selectedDayKey === day.key && styles.tabLinkActive),
                    backgroundColor: isThisDayOff ? "#fff5f5" : "transparent",
                  }}
                  onClick={() => !isLoading && setSelectedDayKey(day.key)}
                >
                  {/* Day Name and Date */}
                  <div style={{ fontWeight: 500 }}>{day.name}</div>
                  <small className="text-muted">{day.date.substring(5)}</small>

             
                  <div className="mt-2">
                    {/* <span
                      className={`badge rounded-pill px-2 py-1 ${isThisDayOff ? "bg-danger" : "bg-success"}`}
                      style={{
                        cursor: "pointer",
                        fontSize: "0.6rem",
                        display: "inline-flex",
                        alignItems: "center",
                        minWidth: "55px",
                        justifyContent: "center",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation(); // ताकि सिर्फ holiday toggle हो, tab click न माने (अगर आप चाहें)

                        if (!isTogglingDayOff && day && day.date) {
                          // 1. पहले उस दिन को सेलेक्ट करें ताकि नीचे का व्यू बदल जाए
                          setSelectedDayKey(day.key);

                          // 2. फिर Holiday toggle फंक्शन चलायें
                          handleToggleDayOff(day);
                        }
                      }}
                    >
                      {isTogglingDayOff && selectedDayKey === day.key ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          style={{ width: "10px", height: "10px" }}
                        ></span>
                      ) : (
                        <>
                          <i
                            className={`fa ${isThisDayOff ? "fa-times-circle" : "fa-check-circle"} me-1`}
                          ></i>
                          {isThisDayOff ? "Holiday" : "Active"}
                        </>
                      )}
                    </span> */}
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ paddingTop: "1.5rem" }}>
            {selectedDay && (
              <>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "1rem",
                    gap: "1rem",
                  }}
                >
                  <h5 style={{ margin: 0 }}>
                    {selectedDay.name}{" "}
                    <span style={{ color: "#6c757d", fontWeight: "normal" }}>
                      ({selectedDay.date})
                    </span>
                  </h5>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.5rem",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button className={`${!isDayOff ? 'btn btn-secondary rounded-pill m-1' : 'btn btn-success rounded-pill'}`} onClick={() => handleToggleDayOff(selectedDay)} disabled={isTogglingDayOff}>{isTogglingDayOff ? 'Saving...' : (!isDayOff ? 'Set Holiday' : 'Unset Holiday')}</button>
                    {!isDayOff && (
                      <>
                        {/* <button
                          className="btn btn-danger rounded-pill m-1"
                          onClick={() => setIsBlockerModalOpen(true)}
                        >
                          <i className="fa fa-clock me-1"></i> Add
                          Unavailability
                        </button> */}
                        <button
                          className="btn btn-info rounded-pill m-1"
                          onClick={() => setIsAddModalOpen(true)}
                        >
                          <i className="fa fa-plus me-1"></i> Add New Slots
                        </button>
                      </>
                    )}
                  </div>
                </div>

                {/* <h6 className="text-muted">Effective Schedule for this Date:</h6> */}
                <h6 className="text-muted mb-3">
                  {typeFilter === "All"
                    ? "Full Schedule"
                    : `Showing: ${typeFilter}`}
                </h6>
                {/* {unifiedScheduleForDay.length > 0 ? ( */}
                {filteredSchedule.length > 0 ? ( 
                 
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
  {filteredSchedule.map((item) => {
    if (item.type === "holiday") {
      return (
        <li key="holiday" style={{ ...styles.slotItem, backgroundColor: "#fff3cd" }}>
          <p style={{ margin: 0, color: "#664d03" }}><i className="fa fa-calendar-times me-2"></i>Holiday</p>
        </li>
      );
    }

    return (
      <li 
        key={item.id} 
        style={{ 
          ...styles.slotItem, 
          opacity: item.isBlocked ? 0.6 : 1, // Unavailable slot thoda light dikhega
          backgroundColor: item.isBlocked ? "#f8f9fa" : "#fff" 
        }}
      >
        <div className="d-flex align-items-center flex-grow-1">
          <i className={`fa ${item.isBlocked ? 'fa-ban text-danger' : 'fa-check-circle text-success'} me-2`}></i>
          <strong style={{ minWidth: "130px" }}>{item.slot}</strong>

          {/* --- Online/Offline Toggle (Sirf tab dikhao jab available ho) --- */}
          {!item.isBlocked && (
            <div className="form-check form-switch ms-4 mb-0">
              <input
                className="form-check-input"
                type="checkbox"
                checked={item.AppoinmentFor === "Online"}
                onChange={() => handleToggleType(item)}
              />
              <label className="form-check-label small fw-bold ml-4">
                  {item.AppoinmentFor === "Online" ? "Online Slot" : "Offline Slot"}
              </label>
            </div>
          )}
        </div>

        <div className="d-flex align-items-center gap-3">
          {/* --- Availability Toggle (MAIN CHANGES) --- */}
          <div className="form-check form-switch mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              style={{ cursor: 'pointer' }}
              checked={!item.isBlocked} // Agar blocked nahi hai toh switch ON rahega
              onChange={() => handleToggleAvailability(item)}
            />
            <label className={`form-check-label small ml-4 ${item.isBlocked ? 'text-danger' : 'text-success'}`}>
              {item.isBlocked ? "Unavailable" : "Available"}
            </label>
          </div>

          {/* --- Delete Button --- */}
          <button
            className="btn btn-outline-danger btn-sm border-0"
            onClick={() => handleDelete(item.id)}
            title="Delete this slot from template"
          >
            <i className="fa fa-trash-alt"></i>
          </button>
        </div>
      </li>
    );
  })}
</ul>
                )
                 : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "1.5rem",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "0.25rem",
                    }}
                  >
                    <p style={{ margin: 0, color: "#6c757d" }}>
                      No schedule for this day.
                    </p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {isAddModalOpen && (
          <div style={styles.modalBackdrop}>
            <div style={styles.modalContent}>
              <div style={styles.modalHeader}>
                <h5 style={{ margin: 0 }}>
                  Add to Template for {selectedDay?.name}s
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setIsAddModalOpen(false)}
                ></button>
              </div>
              {/* Modal Body ke andar ka part replace karein */}
<div style={styles.modalBody}>
  {modalError && (
    <div className="alert alert-danger p-2 small">{modalError}</div>
  )}
  
  {/* SCROLLABLE CONTAINER START */}
  <div style={{ maxHeight: "400px", overflowY: "auto", paddingRight: "10px", overflowX: "hidden" }}>
    {newSlots.map((slot, index) => (
      <div className="mb-4 p-3 border rounded bg-light" key={index}>
        <div className="row g-2 align-items-center">
          
          {/* Appointment Type Dropdown - Har slot ke liye alag */}
          <div className="col-12 mb-2">
            <label className="form-label small fw-bold">Appointment For:</label>
            <select
              className="form-select form-select-sm"
              value={slot.type}
              onChange={(e) =>
                handleTemplateSlotFieldChange(index, "type", null, e.target.value)
              }
            >
              <option value="Offline">Offline Slot</option>
              <option value="Online">Online Slot</option>
            </select>
          </div>

          {/* Start Time Selects */}
          <div className="col-md-6">
            <label className="form-label small">Start Time</label>
            <div className="d-flex gap-1">
              <select className="form-select form-select-sm" value={slot.start.hour} onChange={(e) => handleTemplateSlotFieldChange(index, "start", "hour", e.target.value)}>
                <option value="" disabled>Hr</option>
                {HOUR_OPTIONS.map(h => <option key={h} value={h}>{h}</option>)}
              </select>
              <select className="form-select form-select-sm" value={slot.start.minute} onChange={(e) => handleTemplateSlotFieldChange(index, "start", "minute", e.target.value)}>
                <option value="" disabled>Min</option>
                {MINUTE_OPTIONS.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
              <select className="form-select form-select-sm" value={slot.start.period} onChange={(e) => handleTemplateSlotFieldChange(index, "start", "period", e.target.value)}>
                <option value="" disabled>AM/PM</option>
                {PERIOD_OPTIONS.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
          </div>

          {/* End Time Selects */}
          <div className="col-md-6">
            <label className="form-label small">End Time</label>
            <div className="d-flex gap-1">
              <select className="form-select form-select-sm" value={slot.end.hour} onChange={(e) => handleTemplateSlotFieldChange(index, "end", "hour", e.target.value)}>
                <option value="" disabled>Hr</option>
                {HOUR_OPTIONS.map(h => <option key={h} value={h}>{h}</option>)}
              </select>
              <select className="form-select form-select-sm" value={slot.end.minute} onChange={(e) => handleTemplateSlotFieldChange(index, "end", "minute", e.target.value)}>
                <option value="" disabled>Min</option>
                {MINUTE_OPTIONS.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
              <select className="form-select form-select-sm" value={slot.end.period} onChange={(e) => handleTemplateSlotFieldChange(index, "end", "period", e.target.value)}>
                <option value="" disabled>AM/PM</option>
                {PERIOD_OPTIONS.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
          </div>
        </div>

        {newSlots.length > 1 && (
          <button
            type="button"
            className="btn btn-link text-danger btn-sm p-0 mt-2"
            onClick={() => setNewSlots(newSlots.filter((_, i) => i !== index))}
          >
            <i className="fa fa-trash me-1"></i> Remove Slot
          </button>
        )}
      </div>
    ))}
  </div>
  {/* SCROLLABLE CONTAINER END */}

  <button
    type="button"
    className="btn btn-outline-info btn-sm rounded-pill mt-3"
    onClick={() =>
      setNewSlots([
        ...newSlots,
        {
          start: { hour: "", minute: "", period: "" },
          end: { hour: "", minute: "", period: "" },
          type: "Offline", // Naya slot hamesha default type ke saath aayega
        },
      ])
    }
  >
    <i className="fa fa-plus me-1"></i> Add More Slots
  </button>
</div>
              <div style={styles.modalFooter}>
                <button
                  className="btn btn-secondary rounded-pill"
                  onClick={() => setIsAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-success rounded-pill"
                  onClick={handleSaveSlots}
                  disabled={isSavingSlots}
                >
                  {isSavingSlots ? "Saving..." : "Save to Template"}
                </button>
              </div>
            </div>
          </div>
        )}

        {isBlockerModalOpen && (
          <div style={styles.modalBackdrop}>
            <div style={styles.modalContent}>
              <div style={styles.modalHeader}>
                <h5 style={{ margin: 0 }}>
                  Add Unavailability for {selectedDay?.date}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white "
                  onClick={() => setIsBlockerModalOpen(false)}
                ></button>
              </div>
              <div style={styles.modalBody}>
                {modalError && (
                  <div className="alert alert-danger p-2 small">
                    {modalError}
                  </div>
                )}
                <div className="row g-2 align-items-center">
                  <div className="col-md-6">
                    <label className="form-label small">Start Time</label>
                    <div className="d-flex gap-1">
                      <select
                        className="form-select form-select-sm"
                        value={newBlocker.start?.hour || ""}
                        onChange={(e) =>
                          handleBlockerFieldChange(
                            "start",
                            "hour",
                            e.target.value,
                          )
                        }
                      >
                        <option value="" disabled>
                          Hr
                        </option>
                        {HOUR_OPTIONS.map((h) => (
                          <option key={`b-start-h-${h}`} value={h}>
                            {h}
                          </option>
                        ))}
                      </select>
                      <select
                        className="form-select form-select-sm"
                        value={newBlocker.start?.minute || ""}
                        onChange={(e) =>
                          handleBlockerFieldChange(
                            "start",
                            "minute",
                            e.target.value,
                          )
                        }
                      >
                        <option value="" disabled>
                          Min
                        </option>
                        {MINUTE_OPTIONS.map((m) => (
                          <option key={`b-start-m-${m}`} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>
                      <select
                        className="form-select form-select-sm"
                        value={newBlocker.start?.period || ""}
                        onChange={(e) =>
                          handleBlockerFieldChange(
                            "start",
                            "period",
                            e.target.value,
                          )
                        }
                      >
                        <option value="" disabled>
                          AM/PM
                        </option>
                        {PERIOD_OPTIONS.map((p) => (
                          <option key={`b-start-p-${p}`} value={p}>
                            {p}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small">End Time</label>
                    <div className="d-flex gap-1">
                      <select
                        className="form-select form-select-sm"
                        value={newBlocker.end?.hour || ""}
                        onChange={(e) =>
                          handleBlockerFieldChange(
                            "end",
                            "hour",
                            e.target.value,
                          )
                        }
                      >
                        <option value="" disabled>
                          Hr
                        </option>
                        {HOUR_OPTIONS.map((h) => (
                          <option key={`b-end-h-${h}`} value={h}>
                            {h}
                          </option>
                        ))}
                      </select>
                      <select
                        className="form-select form-select-sm"
                        value={newBlocker.end?.minute || ""}
                        onChange={(e) =>
                          handleBlockerFieldChange(
                            "end",
                            "minute",
                            e.target.value,
                          )
                        }
                      >
                        <option value="" disabled>
                          Min
                        </option>
                        {MINUTE_OPTIONS.map((m) => (
                          <option key={`b-end-m-${m}`} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>
                      <select
                        className="form-select form-select-sm"
                        value={newBlocker.end?.period || ""}
                        onChange={(e) =>
                          handleBlockerFieldChange(
                            "end",
                            "period",
                            e.target.value,
                          )
                        }
                      >
                        <option value="" disabled>
                          AM/PM
                        </option>
                        {PERIOD_OPTIONS.map((p) => (
                          <option key={`b-end-p-${p}`} value={p}>
                            {p}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.modalFooter}>
                <button
                  className="btn btn-secondary rounded-pill"
                  onClick={() => setIsBlockerModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-success rounded-pill"
                  onClick={handleAddBlocker}
                  disabled={isSavingBlocker}
                >
                  {isSavingBlocker ? "Saving..." : "Add Unavailability"}
                </button>
              </div>
            </div>
          </div>
        )}

        <MessageModal
          show={messageModal.show}
          onClose={() => setMessageModal({ ...messageModal, show: false })}
          {...messageModal}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  templateSlots: state.schedule.templateSlots,
  daysOff: state.schedule.daysOff,
  blockers: state.schedule.blockers,
  isLoading: state.schedule.isLoading,
});

const mapDispatchToProps = {
  getScheduleData,
  saveTemplateSlot,
  addDayOff,
  addBlockerSlot,
  deleteScheduleEntry,
};

const styleSheet = document.createElement("style");
styleSheet.innerText = `
  .slot-item-hover:hover .slot-delete-btn { opacity: 1 !important; }
  .form-check-input:checked { background-color: #0d6efd; border-color: #0d6efd; }
  .form-switch .form-check-input { width: 2.5em; cursor: pointer; }
  .slot-controls { display: flex; align-items: center; gap: 15px; }
`;
document.head.appendChild(styleSheet);
export default connect(mapStateToProps, mapDispatchToProps)(ScheduleTime);
